import React from 'react';
import { motion } from 'framer-motion';
import { MousePointerClick, Printer, Paintbrush, Gift } from 'lucide-react';
const steps = [{
  icon: MousePointerClick,
  title: '1. Elegís una plantilla',
  desc: 'Diseños simples y decorativos para practicar o crear piezas finales.'
}, {
  icon: Printer,
  title: '2. La imprimís',
  desc: 'Podés usarla como guía debajo del vidrio, acetato o superficie transparente.'
}, {
  icon: Paintbrush,
  title: '3. Pintás siguiendo el diseño',
  desc: 'Delineás, rellenás con color y creás tu pieza con efecto vitral.'
}, {
  icon: Gift,
  title: '4. Creás piezas listas',
  desc: 'Usá las plantillas en portavelas, frascos, mandalas, cuadros, atrapasoles y souvenirs.'
}];
export function TemplatesSection() {
  return <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 bg-deco-sage/10 relative overflow-hidden" style={{
    backgroundColor: "#D89A8A"
  }} data-id="element-165" data-mp="2nb4hb2q07seo">
      <div className="absolute top-0 right-0 w-64 h-64 bg-deco-sage/20 rounded-full blur-3xl translate-x-1/3 -translate-y-1/3" data-id="element-166" data-mp="1up1xhv1n5gyc"></div>
      <div className="absolute bottom-0 left-0 w-80 h-80 bg-deco-terra/10 rounded-full blur-3xl -translate-x-1/3 translate-y-1/3" data-id="element-167" data-mp="pckwitxueaai"></div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-168" data-mp="tcblcs3t6gce">
        <div className="text-center max-w-3xl mx-auto mb-10 sm:mb-14" data-id="element-169" data-mp="y6ph4vmduphl">
          <div className="inline-flex items-center justify-center gap-2 bg-white text-deco-terra px-5 py-2 rounded-full font-bold text-xs sm:text-sm mb-6 border border-deco-terra/20 shadow-sm" data-id="element-170" data-mp="1350uhgbvzi4k">
            <Printer size={16} data-id="element-171" data-mp="afacgw74vw36" />
            <span className="uppercase tracking-wider" data-id="element-172" data-mp="agli71k53dwx">
              Diseños listos para usar
            </span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl text-deco-text mb-6 font-bold leading-tight" style={{
          color: "#FFFFF0"
        }} data-id="element-173" data-mp="fgzly7epk1p5">
            No necesitás diseñar desde cero
          </h2>
          <p className="text-base sm:text-lg text-deco-taupe font-medium" style={{
          color: "#FFFFFF"
        }} data-id="element-174" data-mp="1qw67lnqfzwb6">
            Una de las claves del falso vitral es trabajar con plantillas. Por
            eso esta guía incluye +100 diseños listos para imprimir.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8" data-id="element-175" data-mp="115ek4phi3yen">
          {steps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-white rounded-[2rem] p-6 sm:p-8 shadow-md border border-deco-warm flex flex-col items-center text-center hover:shadow-lg transition-all duration-300 group" data-id="element-176" data-mp="1g2fc8u3ltvdn" data-mpi={i}>
              <div className="w-16 h-16 rounded-full bg-deco-bg flex items-center justify-center mb-6 text-deco-terra border border-deco-warm group-hover:scale-110 transition-transform duration-300" data-id="element-177" data-mp="sdmdkpvll9fc">
                <step.icon size={28} strokeWidth={1.5} data-id="element-178" data-mp="3vucn3eqe24ls" />
              </div>
              <h3 className="text-lg sm:text-xl font-serif font-bold text-deco-text mb-3" data-id="element-179" data-mp="3vs8nh8zivrrb">
                {step.title}
              </h3>
              <p className="text-deco-text/70 text-sm sm:text-base leading-relaxed" data-id="element-180" data-mp="2g3itcixn7lco">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}